import axiosInstance from "@API/axios";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { setSnackbar } from "@Redux/snackBarSlice";

const usePostItem = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const postItem = (
    url,
    item,
    postCallback,
    successMessage,
    errorMessage,
    showSnackbar = true,
    method = "post",
    isInfo = false
  ) => {
    setLoading(true);
    return axiosInstance[method.toLowerCase()](url, item) // Dynamically call .post or .put
      .then((response) => {
        setLoading(false);
        dispatch(
          setSnackbar({
            open: showSnackbar,
            message: successMessage,
            ...(isInfo ? { severity: "info" } : { error: false }),
          })
        );
        postCallback(response.data, item);
        return response.data;
      })
      .catch((error) => {
        console.error("Error in postItem:", error);

        let errorMsg = "Internal Server Error.";

        const data = error?.response?.data;

        if (typeof data === "object" && data?.details) {
          // If backend returns { details: "some message" }
          errorMsg = data.details;
        } else if (typeof data === "string") {
          // If backend returns a plain string (e.g. "Bad Request")
          errorMsg = data;
        } else if (errorMessage) {
          // Fallback to passed-in error message
          errorMsg = errorMessage;
        }

        dispatch(
          setSnackbar({
            open: true,
            message: errorMsg,
            error: true,
          })
        );

        setLoading(false);
        return false;
      });
  };

  return { loading, postItem };
};

export default usePostItem;
